import { render, staticRenderFns } from "./GitDiffFileContainer.vue?vue&type=template&id=9de0a9c2&scoped=true"
import script from "./GitDiffFileContainer.vue?vue&type=script&lang=js"
export * from "./GitDiffFileContainer.vue?vue&type=script&lang=js"
import style0 from "./GitDiffFileContainer.vue?vue&type=style&index=0&id=9de0a9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de0a9c2",
  null
  
)

export default component.exports